export default __webpack_public_path__ + "static/bcorp-logo-vertical-3e1b9b7ecea8da3bc07154760c660863.svg";